<template>
    <div id="chatbotAnswerListId" class="chatbot-answer-list">

        <!-- PRODUCT LIST -->
        <answer-list-products @onProductListUpdated="handleProductListUpdated"></answer-list-products>

        <!-- FIRST NAME -->
        <answer-first-name @onAnswerListUpdated="answerListUpdated"></answer-first-name>

        <!-- LAST NAME -->
        <answer-last-name @onAnswerListUpdated="answerListUpdated"></answer-last-name>

        <!-- BIRTH DATE -->
        <answer-birth-date @onAnswerListUpdated="answerListUpdated"></answer-birth-date>

        <!-- REGULAR QUESTION ANSWERS -->
        <answer-list-generic-question @onClickedAnswer="handleAnswerClick" @onAnswerListUpdated="answerListUpdated"></answer-list-generic-question>


        <!-- CHAPTER TREE / SEARCH MAIN SYMPTOM -->
        <answer-list-main-symptom @onClickedAnswer="handleAnswerClick" @onAnswerListUpdated="answerListUpdated"></answer-list-main-symptom>


        <!-- RELATED SYMPTOM LIST -->
        <answer-list-related-symptoms  @onClickedAnswer="handleAnswerClick" @onAnswerListUpdated="answerListUpdated"></answer-list-related-symptoms>


        <!-- NO OTHER SYMPTOMS -->
        <answer-list-no-other-symptoms @onClickedAnswer="handleAnswerClick" @onAnswerListUpdated="answerListUpdated"></answer-list-no-other-symptoms>

        <!-- "EVALUATE" button -->
        <answer-list-evaluation-btn @onAnswerListUpdated="answerListUpdated"></answer-list-evaluation-btn>

        <div class="answer-list-evaluation-btn">

            <!-- ----------------------------------------- -->
            <!-- "STUDY Button" button -->
            <!-- ----------------------------------------- -->

            <div v-if="getCurrentAssessmentStatus === getAssessmentStatuses.EVALUATED && getAppPropertyStudyAccess && mustShowUrgentPopup" class="evaluation-btn-container">
                <div class="btn-eval" >
                    <v-btn @click.stop="goToChatbotEvaluationPage()" id="btnGoToAssessmentEvaluation" block color="primary" class="btn color-on-primary-text">{{ text('api.chatbot.btn.evaluate')}}</v-btn>
                </div>
            </div>
        </div>

        <!-- "START NEW ASSESSMENT" button -->
        <answer-list-assessment-stopped @onAnswerListUpdated="answerListUpdated"></answer-list-assessment-stopped>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import { mapGetters } from 'vuex';
    import AnswerListProducts from "./answer-list/AnswerListProducts";
    import AnswerListGenericQuestion from "./answer-list/AnswerListGenericQuestion";
    import AnswerListMainSymptom from "./answer-list/AnswerListMainSymptom";
    import AnswerListRelatedSymptoms from "./answer-list/AnswerListRelatedSymptoms";
    import AnswerListNoOtherSymptoms from "./answer-list/AnswerListNoOtherSymptoms";
    import AnswerListEvaluationBtn from "./answer-list/AnswerListEvaluationBtn";
    import AnswerListAssessmentStopped from "./answer-list/AnswerListAssessmentStopped";

    import AnswerFirstName from "./answer-list/AnswerFirstName";
    import AnswerLastName from "./answer-list/AnswerLastName";
    import AnswerBirthDate from "./answer-list/AnswerBirthDate";

    export default {
        name: 'AnswerList',
        components: {
            AnswerListProducts,
            AnswerListMainSymptom,
            AnswerListRelatedSymptoms,
            AnswerListNoOtherSymptoms,
            AnswerListGenericQuestion,
            AnswerListEvaluationBtn,
            AnswerListAssessmentStopped,
            AnswerFirstName,
            AnswerLastName,
            AnswerBirthDate
        },

        data() {
            return {

            };
        },
        computed: {
            ...mapGetters({
                getCurrentQuestion: 'ChatBotStore/getCurrentQuestion',
                getChapterTree: 'ChatBotStore/getChapterTree',
                // getSearchSymptomInputValue: 'ChatBotStore/getSearchSymptomInputValue',
                getRelatedSymptomList: 'ChatBotStore/getRelatedSymptomList',
                getEvaluationData: 'ChatBotStore/getEvaluationData',
                getCurrentAssessmentStatus: 'ChatBotStore/getCurrentAssessmentStatus',
                getAssessmentStatuses: 'ChatBotStore/getAssessmentStatuses',
                mustShowUrgentPopup: 'AssessmentAlertsStore/getMustShowUrgentPopup',
                getAppPropertyStudyAccess: 'TranslationStore/getAppPropertyStudyAccess'
            }),
        },

        mounted() {
            window.addEventListener('resize', this.handleWindowResize);
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.handleWindowResize)
        },

        methods: {

            handleAnswerClick() {

                this.PfChatbotPlugin.handleAnswerClick();
            },

            goToChatbotEvaluationPage () {

                // @TODO We should reset "chat conversation" (assessment) data in stores. We can do it here, but maybe it's better if we do it always when the user visits the chatbot page  (ChatBotPage component event: "beforeCreate").
                let promiseLoadEvaluationData = this.$store.dispatch("ChatBotStore/loadEvaluationData");
                promiseLoadEvaluationData.then(() => {
                    // console.log("ASSESSMENT finished SAVED");
                    this.$router.push({name: 'PF_ChatBotEvaluationPage'});
                });
            },


            answerListUpdated() {

                this.PfChatbotPlugin.handleOnAnswerListUpdated();

            },

            handleProductListUpdated() {
                this.PfChatbotPlugin.handleOnProductListUpdated();
            },

            handleWindowResize() {

                // Re-compute vertical white spacing, reposition elements in page.
                // setTimeout(() => {
                    this.PfChatbotPlugin.setVerticalSpacing();
                // }, 500);

            }

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

.answer-item {
    display: inline-block;
    border: 1px solid $color-element-outline;
    border-radius: 20px;
    padding: 10px 20px;
    color: $color-brand-primary;
    cursor: pointer;
    margin-right: 15px;
    margin-bottom: 10px;
}


.answer-list-evaluation-btn {
    width: 100%;
    .btn-eval {
        text-align: center !important;
    }
}


@media only screen and (max-width: 599px) {
    .evaluation-btn-container {
        margin: 0 16px;
    }
}
@media only screen and (min-width: 600px) {
    .evaluation-btn-container{
        margin: 0 24px;
    }
}

    @media only screen and (max-width: 599px) {
        .answer-list {
            padding-top: 28px;
        }
    }

    @media only screen and (min-width: 599px) {
        .answer-list {
            padding-top: 24px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/AnswerList.vue